import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { ContentRoute } from "../_metronic/layout";
import { isCongresoDelegado } from "../_helpers/backofficePermissions";
import { DashboardPage } from "./pages/DashboardPage";
import AdminsPage from "./modules/ContentManager/admins/AdminsPage";
import EditAdminsPage from "./modules/ContentManager/admins/EditAdminsPage";
import TextsPage from "./modules/ContentManager/texts/TextsPage";
import EditTextsPage from "./modules/ContentManager/texts/EditTextsPage";
import LiteralsPage from "./modules/ContentManager/literals/LiteralsPage";
import EditLiteralsPage from "./modules/ContentManager/literals/EditLiteralsPage";
import LanguagesPage from "./modules/ContentManager/languages/LanguagesPage";
import EditLanguagesPage from "./modules/ContentManager/languages/EditLanguagesPage";
import UserTypesPage from "./modules/ContentManager/userType/UserTypesPage";
import EditUserTypePage from "./modules/ContentManager/userType/EditUserTypePage";
import EmpleosPage from "./modules/ContentManager/empleo/EmpleosPage";
import EditEmpleoPage from "./modules/ContentManager/empleo/EditEmpleoPage";
import CursosPage from "./modules/ContentManager/curso/CursosPage";
import EditCursoPage from "./modules/ContentManager/curso/EditCursoPage";
import FormacionesPersonalizadasPage from "./modules/ContentManager/curso/FormacionesPersonalizadasPage";
import CategoriasPage from "./modules/ContentManager/categoria/CategoriasPage";
import EditCategoriaPage from "./modules/ContentManager/categoria/EditCategoriaPage";
import UsersPage from "./modules/ContentManager/user/UsersPage";
import EditUsersPage from "./modules/ContentManager/user/EditUserPage";
import ContactsPage from "./modules/ContentManager/contact/ContactsPage";
import EditContactPage from "./modules/ContentManager/contact/EditContactPage";
import MailingsPage from "./modules/ContentManager/mailing/MailingsPage";
import EditMailingPage from "./modules/ContentManager/mailing/EditMailingPage";
import EditPricePage from "./modules/ContentManager/curso/EditPricePage";
import EditDocumentoPage from "./modules/ContentManager/curso/EditDocumentoPage";
import EditInscripcionPage from "./modules/ContentManager/curso/EditInscripcionPage";
import EditDocentePage from "./modules/ContentManager/curso/EditDocentePage";
import PaisesPage from "./modules/ContentManager/paises/PaisesPage";
import EditPaisesPage from "./modules/ContentManager/paises/EditPaisesPage";
import ProvinciasPage from "./modules/ContentManager/provincias/ProvinciasPage";
import EditProvinciasPage from "./modules/ContentManager/provincias/EditProvinciasPage";
import LocalidadesPage from "./modules/ContentManager/localidades/LocalidadesPage";
import EditLocalidadesPage from "./modules/ContentManager/localidades/EditLocalidadesPage";
import NoticiasPage from "./modules/ContentManager/noticia/NoticiasPage";
import EditNoticiaPage from "./modules/ContentManager/noticia/EditNoticiaPage";
import EditUserDocentePage from "./modules/ContentManager/user/EditUserDocentePage";
import DocentesPage from "./modules/ContentManager/user/DocentesPage";
import SociosPage from "./modules/ContentManager/user/SociosPage";
import CalendarioPage from "./modules/ContentManager/calendario/CalendarioPage";
import KnowledgesPage from "./modules/ContentManager/knowledge/KnowledgePage";
import EditKnowledgesPage from "./modules/ContentManager/knowledge/EditKnowledgePage";
import ImagenesPage from "./modules/ContentManager/imagen/ImagenesPage";
import EditImagenesPage from "./modules/ContentManager/imagen/EditImagenesPage";
import EditNewsletterPage from "./modules/ContentManager/newsletter/EditNewsletterPage";
import NewslettersPage from "./modules/ContentManager/newsletter/NewslettersPage";
import BannersPage from "./modules/ContentManager/banner/BannerPage";
import EditBannerPage from "./modules/ContentManager/banner/EditBannerPage";
import CertificadosPage from "./modules/ContentManager/certificado/CertificadoPage";
import EditCertificadoPage from "./modules/ContentManager/certificado/EditCertificadoPage";
import JuntaDirectivaPage from "./modules/ContentManager/juntaDirectiva/JuntaDirectivaPage";
import EditJuntaDirectivaPage from "./modules/ContentManager/juntaDirectiva/EditJuntaDirectivaPage";
import AcuerdoColaboracionPage from "./modules/ContentManager/acuerdoColaboracion/AcuerdoColaboracionPage";
import EditAcuerdoColaboracionPage from "./modules/ContentManager/acuerdoColaboracion/EditAcuerdoColaboracionPage";
import EventosPage from "./modules/ContentManager/evento/EventosPage";
import EditEventoPage from "./modules/ContentManager/evento/EditEventoPage";
import CongresoEdicionesPage from "./modules/ContentManager/congresoEdicion/CongresoEdicionesPage";
import CongresoSitioWebPage from "./modules/ContentManager/congresoEdicion/CongresoSitioWebPage";
import EditCongresoEdicionPage from "./modules/ContentManager/congresoEdicion/EditCongresoEdicionPage";
import VerCongresoEdicionPage from "./modules/ContentManager/congresoEdicion/VerCongresoEdicionPage";
import PaymentManagementPage from "./modules/ContentManager/payment/PaymentManagementPage";
import PaymentOperationsPage from "./modules/ContentManager/payment/PaymentOperationsPage";
import CursoInteresesPage from "./modules/ContentManager/cursoInteres/CursoInteresesPage";

function RootPathRedirect() {
  const user = useSelector((s) => s.authentication?.user, shallowEqual);
  if (isCongresoDelegado(user?.role)) {
    return <Redirect to="/congresos" />;
  }
  return <Redirect to="/dashboard" />;
}

export default function BasePage() {
  return (
    <Switch>
      <Route exact path="/" render={() => <RootPathRedirect />} />
      <ContentRoute path="/dashboard" component={DashboardPage} />

      {/* USERS */}
      {/* Administrators */}
      <ContentRoute from="/admins" component={AdminsPage} />
      <ContentRoute from="/edit-admin/:id?" component={EditAdminsPage} />
      {/* Empleos */}
      <ContentRoute from="/empleos" component={EmpleosPage} />
      <ContentRoute from="/edit-empleo/:id?" component={EditEmpleoPage} />
      {/*Calendario Cursos */}
      <ContentRoute from="/calendario-cursos" component={CalendarioPage} />
      {/* Cursos */}
      <ContentRoute from="/cursos" component={CursosPage} />
      <ContentRoute
        from="/formaciones-personalizadas"
        component={FormacionesPersonalizadasPage}
      />
      <ContentRoute from="/intereses-formaciones" component={CursoInteresesPage} />
      <ContentRoute
        exact
        path="/edit-curso/:cursoId/edit-pricing/:id?"
        component={EditPricePage}
      />
      <ContentRoute
        exact
        path="/edit-curso/:cursoId/edit-documento/:id?"
        component={EditDocumentoPage}
      />
      <ContentRoute
        exact
        path="/edit-curso/:cursoId/edit-inscripcion/:id?"
        component={EditInscripcionPage}
      />
      <ContentRoute
        exact
        path="/edit-curso/:cursoId/edit-docente/:id?"
        component={EditDocentePage}
      />
      <ContentRoute exact path="/edit-curso/:id?" component={EditCursoPage} />
      <ContentRoute
        exact
        path="/edit-formacion-personalizada/:id?"
        component={EditCursoPage}
      />

      {/* MISCELLANY */}
      {/* Tipos de Usuarios */}
      <ContentRoute
        from="/usertypes"
        component={UserTypesPage}
      />
      <ContentRoute
        from="/edit-usertype/:id?"
        component={EditUserTypePage}
      />
      <ContentRoute
        from="/users"
        component={UsersPage}
      />
      <ContentRoute
        from="/edit-user/:id?"
        component={EditUsersPage}
      />
      <ContentRoute
        from="/socios"
        component={SociosPage}
      />
      <ContentRoute
        from="/docentes"
        component={DocentesPage}
      />
      <ContentRoute
        from="/edit-docente/:id?"
        component={EditUserDocentePage}
      />
      {/* Categorias */}
      <ContentRoute
        from="/categorias"
        component={CategoriasPage}
      />
      <ContentRoute
        from="/edit-categoria/:id?"
        component={EditCategoriaPage}
      />
      {/* Languages */}
      <ContentRoute
        from="/languages"
        component={LanguagesPage}
      />
      <ContentRoute
        from="/edit-language/:id?"
        component={EditLanguagesPage}
      />
      {/* Texts */}
      <ContentRoute
        from="/texts"
        component={TextsPage}
      />
      <ContentRoute
        from="/edit-text/:id?"
        component={EditTextsPage}
      />
      {/* Literals */}
      <ContentRoute
        from="/literals"
        component={LiteralsPage}
      />
      <ContentRoute
        from="/edit-literal/:id?"
        component={EditLiteralsPage}
      />
      {/* Knowledges */}
      {/* <ContentRoute
        from="/knowledges"
        component={KnowledgesPage}
      />
      <ContentRoute
        from="/edit-knowledge/:id?"
        component={EditKnowledgesPage}
      /> */}
      {/* Imagenes */}
      <ContentRoute
        from="/imagenes"
        component={ImagenesPage}
      />
      <ContentRoute
        from="/edit-imagen/:id?"
        component={EditImagenesPage}
      />
      {/* Banner */}
      <ContentRoute
        from="/banners"
        component={BannersPage}
      />
      <ContentRoute
        from="/edit-banner/:id?"
        component={EditBannerPage}
      />
      <ContentRoute
        from="/certificados"
        component={CertificadosPage}
      />
      <ContentRoute
        from="/edit-certificado/:id?"
        component={EditCertificadoPage}
      />
      <ContentRoute
        from="/junta-directiva"
        component={JuntaDirectivaPage}
      />
      <ContentRoute
        from="/edit-junta-directiva/:id?"
        component={EditJuntaDirectivaPage}
      />
      <ContentRoute
        from="/acuerdo-colaboracion"
        component={AcuerdoColaboracionPage}
      />
      <ContentRoute
        from="/edit-acuerdo-colaboracion/:id?"
        component={EditAcuerdoColaboracionPage}
      />
      {/* Newsletter */}
      <ContentRoute
        from="/newsletters"
        component={NewslettersPage}
      />
      <ContentRoute
        from="/edit-newsletter/:id?"
        component={EditNewsletterPage}
      />
      {/* Contacts */}
      <ContentRoute
        from="/contacts"
        component={ContactsPage}
      />
      <ContentRoute
        from="/edit-contact/:id?"
        component={EditContactPage}
      />
      {/* Eventos */}
      <ContentRoute
        from="/eventos"
        component={EventosPage}
      />
      <ContentRoute
        from="/edit-evento/:id?"
        component={EditEventoPage}
      />
      {/* Congresos */}
      <ContentRoute
        from="/congresos/sitio-web"
        component={CongresoSitioWebPage}
      />
      <ContentRoute
        from="/congresos"
        component={CongresoEdicionesPage}
      />
      <ContentRoute
        from="/edit-congreso-edicion/:id?"
        component={EditCongresoEdicionPage}
      />
      <ContentRoute
        from="/ver-congreso-edicion/:id"
        component={VerCongresoEdicionPage}
      />
      {/* Gestión de Migraciones */}
      <ContentRoute
        from="/payment-management"
        component={PaymentManagementPage}
      />
      {/* Gestión de Pagos Operativos */}
      <ContentRoute
        from="/payment-operations"
        component={PaymentOperationsPage}
      />
      {/* Mailings */}
      {/* <ContentRoute
        from="/mailings"
        component={MailingsPage}
      />
      <ContentRoute
        from="/edit-mailing/:id?"
        component={EditMailingPage}
      /> */}
      {/* Paises */}
      <ContentRoute from="/paises" component={PaisesPage} />
      <ContentRoute from="/edit-pais/:id?" component={EditPaisesPage} />

      {/* Provincias */}
      <ContentRoute from="/provincias" component={ProvinciasPage} />
      <ContentRoute
        from="/edit-provincia/:id?"
        component={EditProvinciasPage}
      />

      {/* Localidades */}
      <ContentRoute from="/localidades" component={LocalidadesPage} />
      <ContentRoute
        from="/edit-localidad/:id?"
        component={EditLocalidadesPage}
      />
      {/* Noticias */}
      <ContentRoute
        from="/noticias"
        component={NoticiasPage}
      />
      <ContentRoute
        from="/edit-noticia/:id?"
        component={EditNoticiaPage}
      />

      <Redirect to="/error" />
    </Switch>
  );
}
